import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import { mapExperienceToBookingView } from 'lib/experiences/experienceUtils'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import ExperiencePartnershipLabel from 'components/Common/Vendors/Partnership/ExperiencePartnershipLabel'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'
import ImageCarousel from 'components/Luxkit/Carousel/ImageCarousel'
import config from 'constants/config'
import Image from 'components/Common/Image'
import { useAppSelector } from 'hooks/reduxHooks'
import { isMobile } from 'lib/web/deviceUtils'

const Root = styled.div`
  display: flex;
  position: relative;
`

const BadgeContainer = styled.div`
  position: absolute;
  top: ${rem(12)};
  left: ${rem(12)};
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  > * + * {
    margin-top: ${rem(8)};
  }
`

const RightSideBadge = styled.div`
  position: absolute;
  top: ${rem(12)};
  right: ${rem(12)};
`

interface Props {
  experience: App.ExperienceOffer;
  partnershipBadge?: boolean;
  addedBadge?: boolean;
}

function ExperienceImageCarousel(props: Props) {
  const {
    experience,
    partnershipBadge,
    addedBadge,
  } = props

  const viewExp = useMemo(
    () => mapExperienceToBookingView(experience),
    [experience],
  )

  const isMobileDevice = useAppSelector(state => isMobile(state.config.userAgent.osName))
  // Swiping through the offer tiles is tough when the image carousel can also swipe.
  // It might also break the page due to memory limits when scrolling too many tiles.
  // So turn off the image carousel for mobile devices
  const images = useMemo(() => isMobileDevice ? [experience.images[0]] : experience.images, [isMobileDevice, experience.images])

  return (
    <Root>
      <ImageCarousel
        images={images}
      />
      <BadgeContainer>
        {addedBadge && <StatusLabel variant="added" startIcon={<LineCheckIcon />}>Added</StatusLabel>}
        {viewExp.leExclusive && <ProductTypeLabel productType={viewExp.type} />}
        {partnershipBadge && <ExperiencePartnershipLabel price={experience.price} type={experience.productType} />}
      </BadgeContainer>
      {config.EXPERIENCE_BADGE_IMAGE_ID && <RightSideBadge>
        <Image id={config.EXPERIENCE_BADGE_IMAGE_ID} height={80} width={80} />
      </RightSideBadge>}
    </Root>
  )
}

export default ExperienceImageCarousel
